import React, { FC } from 'react';
import {
  Badge,
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  createStyles,
  SvgIcon,
  WithStyles,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ToggleButton } from '@material-ui/lab';
import { Clear, PanToolOutlined } from '@material-ui/icons';

import { EToolActions } from '../hooks/use-tool-action-state';
import AreaIcon from '../../icons/area';

interface SelectionToolProps extends WithStyles<typeof styles> {
  active: boolean;
  action?: EToolActions;
  hasSelected?: boolean;
  onAction?: (action: EToolActions) => void;
  onDeselect?: () => void;
}

const SelectionTool: FC<SelectionToolProps> = (props) => {
  const { active, action, onAction, hasSelected, classes } = props;

  const doAction = (newAction: EToolActions) => () =>
    onAction && onAction(newAction);

  return (
    <>
      {active && (
        <Card className={classes.pointInfo}>
          <CardContent>
            <Box display="flex" justifyContent="space-between">
              <ButtonGroup>
                <ToggleButton
                  title="Двигать карту"
                  selected={action === EToolActions.NOOP}
                  onClick={doAction(EToolActions.NOOP)}
                >
                  <PanToolOutlined />
                </ToggleButton>
                <ToggleButton
                  title="Выбрать точки"
                  selected={action === EToolActions.SELECTION}
                  onClick={doAction(EToolActions.SELECTION)}
                >
                  <SvgIcon viewBox="0 0 122 117">
                    <path d="M74.01,0v11.98H19.13c-3.93,0.01-7.14,3.22-7.15,7.15v17.74H0V19.13c0-1.07,0.09-2.09,0.26-3.14 c0.91-5.37,3.99-10,8.56-12.96c3.13-2,6.6-3.01,10.31-3.03H74.01L74.01,0z M106.86,101.52v16H94.87v-16H79.6V89.53h15.27V69.72 h11.98v19.81h16.03v11.98H106.86L106.86,101.52z M0,48.85h11.98v33.53c0.01,2.69,1.52,5.12,3.9,6.36L10.4,99.4 c-3.97-2.06-7.06-5.36-8.84-9.46C0.52,87.51,0.01,85.02,0,82.39V48.85L0,48.85z M24.89,101.52V89.53h42.73v11.98H24.89 L24.89,101.52z M106.85,57.74H94.87V19.13c-0.01-3.93-3.22-7.14-7.15-7.15h-1.73V0h1.73c1.07,0,2.09,0.09,3.14,0.26 c5.37,0.91,10,3.99,12.96,8.56c2,3.13,3.01,6.6,3.03,10.31V57.74L106.85,57.74z" />
                  </SvgIcon>
                </ToggleButton>
                <Button title="Снять выделение">
                  <SvgIcon viewBox="0 0 122 117">
                    <path d="M 19.130859 0 C 15.420859 0.02 11.950312 1.0292969 8.8203125 3.0292969 C 4.2503125 5.9892969 1.1697656 10.620234 0.25976562 15.990234 C 0.089765625 17.040234 0 18.060859 0 19.130859 L 0 36.869141 L 11.980469 36.869141 L 11.980469 19.130859 C 11.990469 15.200859 15.200859 11.990469 19.130859 11.980469 L 74.009766 11.980469 L 74.009766 0 L 19.130859 0 z M 85.990234 0 L 85.990234 11.980469 L 87.720703 11.980469 C 91.650703 11.990469 94.859141 15.200859 94.869141 19.130859 L 94.869141 57.740234 L 106.84961 57.740234 L 106.84961 19.130859 C 106.82961 15.420859 105.82031 11.950312 103.82031 8.8203125 C 100.86031 4.2503125 96.229375 1.1697656 90.859375 0.25976562 C 89.809375 0.089765625 88.790703 0 87.720703 0 L 85.990234 0 z M 0 48.849609 L 0 82.390625 C 0.01 85.020625 0.52054687 87.509453 1.5605469 89.939453 C 3.3405469 94.039453 6.4303906 97.340391 10.400391 99.400391 L 15.880859 88.740234 C 13.500859 87.500234 11.990469 85.070859 11.980469 82.380859 L 11.980469 48.849609 L 0 48.849609 z M 113.28906 74.986328 L 101.48242 86.794922 L 90.683594 75.996094 L 82.207031 84.474609 L 93.003906 95.271484 L 81.689453 106.58594 L 90.167969 115.06445 L 101.48242 103.75 L 101.48828 103.74414 L 111.9375 114.19141 L 120.4082 105.7207 L 109.95312 95.265625 L 121.75977 83.458984 L 113.28906 74.986328 z M 24.890625 89.529297 L 24.890625 101.50977 L 67.619141 101.50977 L 67.619141 89.529297 L 24.890625 89.529297 z " />
                  </SvgIcon>
                </Button>
              </ButtonGroup>
              <ButtonGroup>
                <ToggleButton
                  title="Выбрать область поиска"
                  selected={action === EToolActions.SELECT_AREA}
                  onClick={doAction(EToolActions.SELECT_AREA)}
                >
                  <AreaIcon />
                </ToggleButton>
                <Button
                  title="Удалить область поиска"
                  onClick={doAction(EToolActions.UNSELECT_AREA)}
                >
                  <Badge
                    badgeContent={
                      <Clear
                        fillOpacity={0.5}
                        style={{
                          fontSize: '2.3rem',
                          marginLeft: -20,
                          marginTop: 20,
                        }}
                      />
                    }
                  >
                    <AreaIcon />
                  </Badge>
                </Button>
              </ButtonGroup>
              <ButtonGroup>
                <Button title="Выгрузить в Excel" disabled={!hasSelected}>
                  <SvgIcon viewBox="0 0 512 512">
                    <path d="M476.624,97.457H289.746v57.656h43.131c7.934,0,14.371,6.458,14.371,14.413c0.001,7.957-6.438,14.415-14.371,14.415    h-43.131v28.831h43.131c7.934,0,14.371,6.458,14.371,14.408c0.001,7.96-6.438,14.417-14.371,14.417h-43.131v28.828h43.131    c7.934,0,14.371,6.457,14.371,14.415c0.001,7.951-6.438,14.409-14.371,14.409h-43.131v28.832h43.131    c7.934,0,14.371,6.458,14.371,14.417c0,7.956-6.438,14.412-14.371,14.412h-43.131v57.653h186.878    c7.938,0,14.376-6.455,14.375-14.416V111.87C490.999,103.913,484.562,97.457,476.624,97.457z M419.125,356.909h-28.75    c-7.934,0-14.377-6.456-14.377-14.412c0-7.959,6.443-14.417,14.377-14.417h28.75c7.933,0,14.373,6.458,14.373,14.417    C433.498,350.453,427.058,356.909,419.125,356.909z M419.125,299.248h-28.75c-7.934,0-14.377-6.458-14.377-14.409    c0-7.958,6.443-14.415,14.377-14.415h28.75c7.933,0,14.373,6.457,14.373,14.415C433.498,292.79,427.058,299.248,419.125,299.248z     M419.125,241.596h-28.75c-7.934,0-14.377-6.457-14.377-14.417c0-7.95,6.443-14.408,14.377-14.408h28.75    c7.933,0,14.373,6.458,14.373,14.408C433.498,235.139,427.058,241.596,419.125,241.596z M419.125,183.939h-28.75    c-7.934,0-14.377-6.458-14.377-14.415c0-7.955,6.443-14.413,14.377-14.413h28.75c7.933,0,14.373,6.458,14.373,14.413    C433.498,177.482,427.058,183.939,419.125,183.939z" />
                    <path d="M274.548,43.115c-3.282-2.738-7.681-3.922-11.819-3.053L32.731,83.3c-6.814,1.275-11.73,7.211-11.73,14.157v317.106    c0,6.919,4.916,12.883,11.73,14.157l229.997,43.24c0.862,0.17,1.754,0.259,2.646,0.259c3.334,0,6.582-1.152,9.172-3.318    c3.309-2.734,5.199-6.828,5.199-11.099v-43.239v-57.653V328.08v-28.832v-28.824v-28.828v-28.826v-28.831v-28.827V97.457V54.219    C279.745,49.921,277.854,45.855,274.548,43.115z M217.338,324.504c-2.732,2.395-6.1,3.578-9.466,3.578    c-3.992,0-7.96-1.675-10.809-4.954l-41.799-47.891l-36.659,47.277c-2.843,3.665-7.071,5.565-11.354,5.565    c-3.073,0-6.21-0.98-8.857-3.025c-6.236-4.898-7.388-13.953-2.499-20.241l40.078-51.657l-39.532-45.317    c-5.232-5.97-4.627-15.078,1.351-20.32c5.923-5.25,15.01-4.703,20.269,1.357l35.88,41.102l42.583-54.889    c4.909-6.253,13.938-7.407,20.176-2.504c6.238,4.896,7.395,13.95,2.507,20.238l-45.978,59.271l45.46,52.088    C223.918,310.152,223.316,319.262,217.338,324.504z" />
                  </SvgIcon>
                </Button>
              </ButtonGroup>
            </Box>
          </CardContent>
        </Card>
      )}
    </>
  );
};

const styles = () =>
  createStyles({
    pointInfo: {
      marginTop: '10px',
      width: 345,
      '& .MuiCardContent-root': {
        paddingBottom: '16px',
      },
    },
  });

export default withStyles(styles)(SelectionTool);
